import { ScrollCTA } from 'formlabs-web-components/CTAs';
import { Cell, Grid, Section } from 'formlabs-web-components/Grid';
import { LargeLink, SuperButton } from 'formlabs-web-components/Link';
import {
  Accordion,
  AccordionItem,
  Picture,
  SVG,
  Video,
  Tile,
  TileGroup,
  Carousel,
  ProductCarousel,
  FlushPanel,
  FullWidthImage
} from 'formlabs-web-components/Media';
import {
  PopLockGroup,
  PopLockItem,
  PopLockSection
} from 'formlabs-web-components/PopLock';
import {
  Announcement,
  Blockquote,
  Callout,
  Eyebrow,
  Icon,
  Pill
} from 'formlabs-web-components/Type';
import {
  AlignmentWrapper,
  CombinedHeadlines
} from 'formlabs-web-components/Wrapper';

import EventCardsFilter from './filtering/EventCardsFilter.js';

import {
  BasicTile,
  BasicTileGroup,
  ButtonPlugin as Button,
  Card,
  EventCard,
  CardList,
  CalloutSection,
  CheckmarkList,
  ContactSales,
  SwabRequest,
  Countdown,
  DataSheets as Datasheets,
  DropdownMenu,
  EmbeddedContactSales,
  FeatureToggleWrapper,
  FeatureVersion,
  HeaderPlugin as Header,
  HeroSection,
  ImageRevealWrapper,
  MaterialCard,
  MediaLink,
  MenuListSection,
  MiniTechSpecsTable,
  Module,
  Modal,
  ModalOpener,
  NewsletterSignUpSection,
  NumberLine,
  OrderedLinkList,
  ProductCard,
  Quote,
  QuoteCarousel,
  SimpleCallout,
  SingleDatasheet,
  SocialEmbedSection,
  SocialMediaIcons,
  svgInteractive as SvgInteractive,
  TabbedSection,
  TabbedSectionItem,
  Table,
  TableOfContents,
  TechSpecsItem,
  UnitSwitchSection,
  VerticalTabSection,
  VerticalTab,
  VideoAccordion,
  VideoAccordionItem,
  VideoCard,
  VideoScrollSection,
  VideoSection,
  WistiaEmbed,
  Wrapper,
  YoutubeEmbed,
  YoutubeModal
} from './content';
import SpecTable, { SpecRow, SpecItem } from './spec-table/SpecTable';
import { NewsletterSignUp, TeaserSignUp, PreformDownload } from './forms/';
import { StarOfDavid } from './star';
import { Graph } from './graph';
import { SynchronousVideos } from './synchronous-videos';
import Locations from './locations';
import {
  AddToCartPlugin as AddToCart,
  CategoryButtonPlugin as CategoryButton,
  ProductPageHeroPlugin as ProductPageHero,
  Product,
  ProductHero,
  ProductList,
  ProductCategoryPlugin as ProductCategory,
  ProductDetailPlugin as ProductDetail,
  ProductButtonPlugin as ProductButton,
  PricePlugin as Price
} from './storefront';
import StorefrontCategory from './storefront/next/FilteredProductList';
import Text from './cms/TextPlugin';
import { ColorPicker } from './colorpicker';
import {
  Footer,
  HeaderMenu,
  Redirect,
  StoreMenu,
  CtaStickyNav
} from './navigation/';
import { Roi } from './roi';
import { SampleRequest } from './request-sample-part';
import { FeaturedWebinar, WebinarList } from './webinars';
import { AmbassadorList } from './ambassadors';
import {
  Experiment,
  Conversion as ExperimentConversion,
  Variant as ExperimentVariant
} from './experiment/index';
import {
  Form,
  MarketoForm,
  Input as InputField,
  Select as SelectField,
  Option as SelectOption,
  TextArea as TextAreaField,
  PresetSelect,
  FormSubmit,
  Message
} from './form-builder/index';

// Provides the component to cms placeholder mapping
export default {
  EventCardsFilter,
  AddToCart,
  CategoryButton,
  NewsletterSignUp,
  PreformDownload,
  FeatureToggleWrapper,
  FeatureVersion,
  GlobalFeatureToggleWrapper: FeatureToggleWrapper,
  GlobalFeatureVersion: FeatureVersion,
  Product,
  ProductButton,
  ProductCategory,
  ProductDetail,
  ProductHero,
  ProductPageHero,
  ProductList,
  Price,
  TeaserSignUp,
  ScrollCTA,
  SpecItem,
  SpecRow,
  SpecTable,
  StarOfDavid,
  StarOfDavidWithOptions: StarOfDavid,
  Graph,
  SynchronousVideos,
  Locations,
  AlignmentWrapper,
  CombinedHeadlines,
  Announcement,
  Blockquote,
  Callout,
  Eyebrow,
  Icon,
  Pill,

  PopLockGroup,
  PopLockItem,
  PopLockSection,

  Accordion,
  AccordionItem,
  Picture,
  SVG,
  Video,
  Tile,
  TileGroup,
  Carousel,
  ProductCarousel,
  carousel: Carousel,
  FlushPanel,
  FullWidthImage,

  Cell,
  Grid,
  Section,

  LargeLink,
  SuperButton,

  Card,
  EventCard,
  ProductCard,
  CardList,
  FourColumn: Grid,
  Scroll: ScrollCTA,
  SvgInteractive,
  Text,
  ThreeColumn: Grid,
  TwoColumn: Grid,
  BasicTile,
  BasicTileGroup,
  CalloutSection,
  CheckmarkList,
  ContactSales,
  Countdown,
  Datasheets,

  Button,
  LocalizedButton: Button,
  DropdownMenu,
  EmbeddedContactSales,
  Header,
  HeroSection,
  ImageRevealWrapper,
  MaterialCard,
  MediaLink,
  MenuListSection,
  MiniTechSpecsTable,
  Module,
  Modal,
  ModalOpener,
  NewsletterSignUpSection,
  NumberLine,
  OrderedLinkList,
  Quote,
  QuoteCarousel,
  SimpleCallout,
  SingleDatasheet,
  SocialEmbedSection,
  SocialMediaIcons,
  TabbedSection,
  TabbedSectionItem,
  Table,
  TableOfContents,
  TechSpecsItem,
  UnitSwitchSection,
  VerticalTabSection,
  VerticalTab,
  VideoAccordion,
  VideoAccordionItem,
  VideoCard,
  VideoScrollSection,
  VideoSection,
  WistiaEmbed,
  Wrapper,
  YoutubeEmbed,
  YoutubeModal,

  ColorPicker,

  Footer,
  HeaderMenu,
  Redirect,
  StoreMenu,
  CtaStickyNav,
  FlatStoreMenu: StoreMenu,
  BundleList: ProductCategory,

  Roi,
  SampleRequest,
  FeaturedWebinar,
  WebinarList,
  AmbassadorList,
  SwabRequest,

  Experiment,
  ExperimentConversion,
  ExperimentVariant,

  Form,
  MarketoForm,
  InputField,
  SelectField,
  SelectOption,
  TextAreaField,
  PresetSelect,
  FormSubmit,
  ErrorMessage: Message,
  SuccessMessage: Message,

  StorefrontCategory
};
